<template>
  <div class="xm" ref="imgg">
    <div class="fd"></div>
    <img :src="src" alt="" ref="src" width="100%">
  </div>
</template>

<script>
export default {
props:{
        src:{
            default:'',
            type:String,
        },
    },
}
</script>

<style>
.xm{
    position: relative;
    margin: 0px auto;
    width: 666px;
    cursor: pointer;
}
.fd{
    position: absolute;
    bottom: 8px;
    right:8px;
    width: 51px;
    height: 51px;
    background: url('../assets/img/fdj.png')no-repeat;
}
</style>